// Minimal `process` shim for the browser.
//
// The Azure Speech SDK transitively requires the Node `util`/`assert` polyfills (via
// https-proxy-agent), and `util` references the Node `process` global, which doesn't exist
// in the browser. Without this, the SDK throws "ReferenceError: process is not defined" the
// first time it lazy-loads. Provides just enough of the process API for those polyfills.
//
// Loaded via each app's `polyfills` array so it runs before any application or lazy chunk code.
type MinimalProcess = {
	env: Record<string, string | undefined>;
	browser: boolean;
	version: string;
	versions: Record<string, string>;
	nextTick: (cb: (...args: unknown[]) => void, ...args: unknown[]) => void;
};

const globalScope = globalThis as typeof globalThis & { process?: MinimalProcess };

if (!globalScope.process) {
	globalScope.process = {
		env: {},
		browser: true,
		version: '',
		versions: {},
		nextTick: (cb, ...args) => setTimeout(() => cb(...args), 0)
	};
}
